module.exports = __webpack_public_path__ + "img/Devices.b75486ba.svg";